var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"20","viewBox":"0 0 40 40","width":"20"}},[_c('path',{attrs:{"d":"M38 12.83l-2.83-2.83-11.17 11.17-11.17-11.17-2.83 2.83 11.17 11.17-11.17 11.17 2.83 2.83 11.17-11.17 11.17 11.17 2.83-2.83-11.17-11.17z","fill":"gray"}}),_c('path',{attrs:{"d":"M0 0h48v48h-48z","fill":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }